import React, { FC, useMemo } from 'react';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import { ITenderHighlight } from 'src/models/procurements/Preview/types';

interface IProps {
  highlights?: ITenderHighlight[];
  cpvCodes?: string[];
}

export const TenderPreviewMatchesTotal: FC<IProps> = ({ highlights, cpvCodes }) => {
  const { t } = useTranslation();

  const totalKeywords = useMemo(() => {
    return highlights ? highlights.reduce((count, current) => count + current.highlights.length, 0) : 0;
    // return highlights ? highlights.flatMap(highlight => highlight.highlights).length : 0;
  }, [highlights]);

  return (
    <>
      {(!!totalKeywords || !!cpvCodes?.length) && (
        <>
          <h5 className={styles.title}>{t('Tenders.matches')}</h5>
          {!!totalKeywords && (
            <span className={styles.desc}>{t('Tenders.totalMatchKeyword', { count: totalKeywords })}</span>
          )}
          {!!cpvCodes?.length && (
            <span className={styles.desc}>{t('Tenders.totalMatchCpv', { count: cpvCodes.length })}</span>
          )}
        </>
      )}
    </>
  );
};

export default TenderPreviewMatchesTotal;
